import { Tooltip, Typography } from '@mui/material';
import React from 'react';
import { truncateString } from '../../commonFunctions/CommonFunctions';

// Props interface
interface StatusProps {
    value: string;
    toolTip?: boolean;
    style?: React.CSSProperties;
}

// Function to get background and text color
const getStatusStyle = (value: string): { bg: string; color: string } => {
    switch (value?.toLowerCase()) {
        case 'delivered':
        case 'approved':
        case 'completed':
        case 'active':
       
            return { bg: '#D4F2E7', color: '#007B5A' }; // Light green bg, green text

        case 'rejected':
        case 'incomplete':
        case 'not approved':
        case 'not assigned':
        case 'absent':
        case 'cancelled':
        case 'offline':
            return { bg: '#F8D7DA', color: '#D2122E' }; // Light red bg, red text

        case 'inactive':
        case 'in active':
            return { bg: '#E0E0E0', color: '#757575' }; // Light gray bg, gray text

        case 'pending':
             case 'packed':
             case 'inprocess':
            return { bg: '#FDEDA5', color: '#A67800' }; // Yellow bg, brown text

        case 'processing':
        case  'assigned':
            return { bg: '#DCEBFF', color: '#1D4ED8' }; // Light blue bg, blue text

        case  'shipped':
            return { bg: '#DCEBFF', color: '#F527EB' };

        default:
            return { bg: '#E0E0E0', color: '#000000' }; // Default neutral
    }
};

export const WSStatus: React.FC<StatusProps> = React.memo(({ value, toolTip = false, style }) => {
    const { bg, color } = getStatusStyle(value);

    const content = (
        <div
            style={{
                backgroundColor: bg,
                color: color,
                padding: '6px 16px',
                borderRadius: 9999,
                display: 'inline-block',
                fontSize: '0.875rem',
                fontWeight: 500,
                textAlign: 'center',
                minWidth: 80,
                ...style,
            }}
        >
            {truncateString(value, 20)}
        </div>
    );

    return toolTip ? (
        <Tooltip title={value} placement="top">
            <span>{content}</span>
        </Tooltip>
    ) : (
        content
    );
});
